import { DatePicker } from "@base/ui/DatePicker";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";
import dayjs from "dayjs";
import { useCallback } from "react";

export interface MeetingRoomDatePickerProps {
  value: Date;
  onValueChange: (date: Date) => void;
}

export function MeetingRoomDatePicker({ value, onValueChange }: MeetingRoomDatePickerProps) {
  const handlePrevMonth = useCallback(() => {
    onValueChange(dayjs(value).subtract(1, "day").toDate());
  }, [value, onValueChange]);

  const handleNextMonth = useCallback(() => {
    onValueChange(dayjs(value).add(1, "day").toDate());
  }, [value, onValueChange]);

  return (
    <div className="flex flex-wrap gap-4 justify-center items-center">
      <button type="button" className="flex-shrink-0" onClick={handlePrevMonth}>
        <Icon path={mdiChevronLeft} size="1.5rem" className="text-gray-1000" />
      </button>
      <DatePicker
        selectionMode="single"
        color="primary"
        defaultValue={[value]}
        value={[value]}
        onValueChange={(details) => {
          onValueChange(new Date(details.valueAsString[0]));
        }}
      >
        <DatePicker.Control>
          <span className="flex gap-1 items-center p-1 hover:bg-gray-100">
            <span className="text-[#252525] text-center font-semibold leading-[1.3] tracking-[-0.32px] shrink-0">
              {dayjs(value).format("MMM, DD, YYYY")}
            </span>
          </span>
        </DatePicker.Control>
        <DatePicker.Content />
      </DatePicker>
      <button type="button" className="flex-shrink-0" onClick={handleNextMonth}>
        <Icon path={mdiChevronRight} size="1.5rem" className="text-gray-1000" />
      </button>
    </div>
  );
}
